module.exports = ".code-container{padding:15px 10px;background-color:#f0f0f0;font-family:monospace;line-height:10px}\n"